/*
  Active Field
 */

var ActiveField = (function ($) {
  var m = (function () {
    var name = 'Active Field';
    var version = '0.0.1';

    /*
      Local variable declarations
    */

    /*
      Handlers
    */
    var handlers = {
      checkItemActive: function ($input) {
        var $field = $input.closest('.js-active-field');

        if ($input.is(':focus') || $input.val()) {
          $field.addClass('is-active');
        }
        else {
          $field.removeClass('is-active');
        }
      },
    };

    /*
      List handlers that should be
      accessible in the global namespace
    */
    var publicHandlers = [
      'checkItemActive',
    ];

    /*
      Events
    */
    var events = {
      onInputChange: function () {
        $('.js-active-field').each(function () {
          var $field = $(this);
          var $input = $field.find('input:not([type=hidden]), textarea:not([type=hidden])').first();

          $input.on('blur change focus', function () {
            handlers.checkItemActive($input);
          });
        });
      },
      pageLoad: function () {
        $('.js-active-field').each(function () {
          handlers.checkItemActive($(this));
        });
      },
    };

    /*
      List events in the order they
      should be bound. Any unlisted
      events will be registered last.
    */
    var eventOrder = [
      'pageLoad',
    ];

    /************************************************************************************
      DON'T EDIT BELOW THIS LINE
    ************************************************************************************/

    var bindEvents = function () {
      var eventNames = Object.keys(events);
      for (var i = 0; i < eventNames.length; i++) {
        var eventName = eventNames[i];
        if (eventOrder.indexOf(eventName) < 0) {
          eventOrder.push(eventName);
        }
      }

      for (var i = 0; i < eventOrder.length; i++) {
        var eventName = eventOrder[i];
        var event = events[eventName];

        if (event !== undefined) {
          if (typeof (event) === 'function') {
            try {
              event();
            }
            catch (e) {
              console.error('Event binding failed: ' + eventName);
              console.error(e);
            }
          }
          else {
            console.error('Event is not a function: ' + eventName);
          }
        }
        else {
          console.error('Event is undefined: ' + eventName);
        }
      }
    };

    var registerPublicHandlers = function () {
      for (var i = 0; i < publicHandlers.length; i++) {
        var handlerName = publicHandlers[i];
        var handler = handlers[handlerName];
        if (handler !== undefined) {
          if (typeof (handler) === 'function') {
            interface[handlerName] = handler;
          }
          else {
            console.error('Handler is not a function: ' + handlerName);
          }
        }
        else {
          console.error('Handler is undefined: ' + handlerName);
        }
      }
    };

    var interface = {
      _init_: function () {
        registerPublicHandlers();
        bindEvents();
        delete interface._init_;
      },
      toString: function () {
        return name + ' (version ' + version + ')';
      },
    };

    return interface;
  }());

  // Error-safe initialization
  $(function () {
    try {
      m._init_();
    }
    catch (e) {
      console.error('Module failed to initialize: ' + m);
      console.error(e);
    }
  });

  return m;
}(jQuery));
